import React from "react";
import {
  Redirect,
  Route,
  Switch,
  useRouteMatch,
  withRouter,
} from "react-router-dom";

import Header from "../../header";
import Footer from "../../footer";
import DecoMethods from "./deco-methods";
import AdditionalLocations from "./additional-location";
import MastersSubHeader from "./MastersSubHeader";
import BURunCharge from "./BURUNCharge";
//import ColorPricingCategory from "./color-pricing-category"
import ColorPricingCategory from "./color-pricing-category";
import CategorySecondaryOption from "./category-secondary-option";
//import BURunCharge from "./BU-RunCharges";
import GlobalValues from "./GlobalValues";
import { MastersContextProvider } from "../../../contexts/masters.context";
import ExceptionCategory from "./ExceptionCategory";
import SetupCharges from "./setup-charges";
import Products from "./products";
import DecoMethodCategory from "./deco-method-category";

function MastersLyout(props) {
  const { path } = useRouteMatch();

  return (
    <MastersContextProvider>
      <div className="container-fluid">
        <div
          id="kt_wrapper"
          className="d-flex flex-column flex-row-fluid wrapper"
        >
          <Header
            loginSuccess={props.loginSuccess}
            sessionLogout={props.sessionLogout}
          >
            <MastersSubHeader />
          </Header>
          <Switch>
            <Route path={`${path}/global-values`}>
              <GlobalValues />
            </Route>

            <Route path={`${path}/deco-methods`}>
              <DecoMethods />
            </Route>

            <Route path={`${path}/deco-method-category`}>
              <DecoMethodCategory />
            </Route>

            <Route path={`${path}/additional-locations`}>
              <AdditionalLocations />
            </Route>
            {/* <Route exact path={`${path}/BURunCharges`}>
              <BURunCharge />
            </Route> */}
            <Route path={`${path}/color-pricing-category`}>
              <ColorPricingCategory />
            </Route>

            <Route path={`${path}/category-secondary-option`}>
              <CategorySecondaryOption />
            </Route>

            <Route path={`${path}/exception-category`}>
              <ExceptionCategory />
            </Route>
            <Route path={`${path}/setup-charges`}>
              <SetupCharges />
            </Route>
            {/* <Route path={`${path}/additional-locations`}>
            <AdditionalLocations />
          </Route> */}
            <Route path={`${path}/bu-run-charge`}>
              <BURunCharge />
            </Route>
            <Route path={`${path}/products`}>
              <Products />
            </Route>
            <Route exact path={path}>
              <Redirect to={`${path}/deco-methods`} />
            </Route>
          </Switch>
          <Footer></Footer>
        </div>
      </div>
    </MastersContextProvider>
  );
}

export default withRouter(MastersLyout);
